import { useEffect } from "react";

import { IFRAME_MESSAGES } from "../constants/IframeMessage";

interface UseIframeSignalProps {
  /** iframe 준비 완료 여부 */
  isIframeReady: boolean;
}

/**
 * 데모 애플리케이션이 부모 창에 "Iframe Loaded" 신호를 전송하는 훅
 *
 * @param isIframeReady - true일 때 신호 전송 중단
 *
 * @example
 * ```tsx
 * const [isIframeReady, setIsIframeReady] = useState(false);
 * useIframeSignal({ isIframeReady });
 * ```
 */
export const useIframeSignal = ({ isIframeReady }: UseIframeSignalProps) => {
  useEffect(() => {
    let retryCount = 0;
    const maxRetries = 100;
    const intervalId = setInterval(() => {
      if (retryCount < maxRetries && !isIframeReady) {
        window.parent.postMessage(IFRAME_MESSAGES.IFRAME_LOADED, "*");
        retryCount++;
      } else {
        clearInterval(intervalId);
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, [isIframeReady]);
};
